import { render, staticRenderFns } from "./_SystemsBlock.vue?vue&type=template&id=7d1ae3e8&scoped=true&"
import script from "./_SystemsBlock.vue?vue&type=script&lang=ts&"
export * from "./_SystemsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./_SystemsBlock.vue?vue&type=style&index=0&id=7d1ae3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1ae3e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VIcon,VSwitch})
